(function() {
  function initEarlyAccess(container) {
    if (!container) {
      return;
    }

    var saleState = container.getAttribute('data-sale-state');
    if (saleState === 'public') {
      return;
    }

    var gate = container.querySelector('[data-early-access-gate]');
    var products = container.querySelector('[data-early-access-products]');
    var form = container.querySelector('[data-early-access-form]');
    var input = container.querySelector('[data-early-access-input]');
    var error = container.querySelector('[data-early-access-error]');
    var expectedPassword = container.getAttribute('data-password') || '';
    var storageKey = container.getAttribute('data-storage-key') || 'early_access_unlock';

    if (!gate || !products || !form || !input) {
      return;
    }

    function showProducts() {
      gate.hidden = true;
      products.hidden = false;
    }

    function showGate() {
      gate.hidden = false;
      products.hidden = true;
    }

    if (window.localStorage && localStorage.getItem(storageKey) === 'true') {
      showProducts();
    } else {
      showGate();
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      if (input.value.toLowerCase() === expectedPassword.toLowerCase() && expectedPassword !== '') {
        if (window.localStorage) {
          localStorage.setItem(storageKey, 'true');
        }
        if (error) {
          error.hidden = true;
        }
        showProducts();
      } else if (error) {
        error.hidden = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var containers = document.querySelectorAll('[data-early-access]');
    containers.forEach(initEarlyAccess);
  });
})();